export const professionalLearningIntroSteps = [
  {
    element: '#resources-title',
    intro: 'Professional Learning is where you can view short videos that provide overview information on different components of WordFlight. This is also where you can view the videos to introduce students to the WordFlight Screener and Diagnostic. These videos are helpful to show students before they start the WordFlight Screener or Diagnostic.'
  }
];